<!-- EditCompanyProfileModal.vue -->
<template>
  <b-modal v-model="showModal" title="تعديل ملف المنشأة" no-close-on-backdrop>
    <b-card title="تعديل ملف المنشأة">
      <b-form class="p-4" @submit.prevent="editCompany">
        <b-row>
      <b-col md="6" cols="12">
        <label>نشاط المنشأة</label>
        <b-form-input
          v-model="companyData.category"
          name="Category"
          type="text"
          placeholder="نشاط المنشأة "
        />
      </b-col>
      <b-col md="6" cols="12">

        <label>الجوال</label>
        <b-form-input
          v-model="companyData.phone"
          name="phone"
          type="text"
          placeholder="الجوال "
        />
    </b-col>
</b-row>
        <label>العنوان</label>

        <b-form-input
          v-model="companyData.address"
          name="address"
          type="text"
          placeholder="العنوان "
        />
        <label>الوصف</label>

        <b-form-textarea
          id="description"
          v-model="companyData.description"
          trim
          type="text"
          placeholder="الوصف"
        />
        <label>تاريخ التأسيس</label>

        <VueDatePicker
          v-model="companyData.established_at"
          :enable-time-picker="false"
          model-type="yyyy-MM-dd"
        ></VueDatePicker>

        <label>موقع الويب</label>

        <b-form-input
          id="Website"
          v-model="companyData.website"
          trim
          placeholder="موقع الويب"
        />
        <b-row>
            <b-col md="6" cols="12">

        <label>تاريخ انتهاء السجل</label>

        <VueDatePicker
          v-model="companyData.commercial_register_expire_at"
          :enable-time-picker="false"
          model-type="yyyy-MM-dd"
        ></VueDatePicker>
       </b-col>
      <b-col md="6" cols="12">
        <label> رقم السجل</label>

        <b-form-input
          v-model="companyData.commercial_register_num"
          name="commercial"
          type="text"
          placeholder="رقم السجل "
        />
      </b-col>
      </b-row>
        <label>مكان السجل</label>

        <b-form-input
          v-model="companyData.commercial_register_address"
          name="commercial_register_address"
          type="text"
          placeholder="مكان السجل "
        />
        <label>المدينة </label>

        <v-select v-model="companyData.city_id" :options="cities" label="name"     :reduce="(cities) => cities.id"
    value="id"></v-select>

        <b-media no-body class="mb-1">
          <b-media-aside>
            <b-link>
              <b-img
                ref="previewEl"
                :src="companyData.image.url"
                height="80"
                width="80"
              />
            </b-link>
            <!--/ image -->
          </b-media-aside>

          <b-media-body>
            <!-- upload button -->
            <b-button
              variant="primary"
              size="sm"
              class="mt-25 mr-75"
              @click="selectFile()"
            >
              اضافة شعار
            </b-button>
            <input
              ref="refInputEl"
              type="file"
              accept=".jpg, .png"
              style="display: none"
              @change="changeProfile"
            />
            <!--/ upload button -->
          </b-media-body>
        </b-media>
        <b-col
          cols="12"
          class="d-flex align-items-center justify-content-center"
        >
          <b-button
            class="form-btn"
            v-if="!loader"
            variant="primary"
            type="submit"
            block
          >
            <span> حفظ</span>
          </b-button>
          <b-button
            class="form-btn"
            v-if="loader"
            variant="primary"
            disabled
            block
          >
            <b-spinner small type="grow" />
            برجاء الانتظار...
          </b-button>
        </b-col>
      </b-form>
    </b-card>
  </b-modal>
</template>

  <script>
import axios from "axios";
import vSelect from 'vue-select';

export default {
  components: {vSelect},
  data() {
    return {
      showModal: false,
      loader: false,
      cities:[],
      companyData: {
        image: {
          url: null,
        },
        established_at: new Date(),
      },
      image: "",
    };
  },
  mounted(){
    this.fetchCities()
    this.fetchCompany()
  },
  methods: {
    selectFile() {
      this.$refs.refInputEl.click();
    },
    changeProfile(e) {
      const input = e.target;
      if (input.files && input.files.length > 0) {
        const reader = new FileReader();
        reader.onload = (event) => {
          this.companyData.image.url = event.target.result;
        };
        this.image = input.files[0]
        reader.readAsDataURL(input.files[0]);
      }
    },
    async fetchCities() {
  try {
    const response = await axios.get('companies/cities', {
      headers: {
        'Accept-Language': 'ar',
      },
    });

    this.cities = response.data.data.cities; // Assign the API response to the data property
  } catch (error) {
    console.error('Error fetching cities details:', error);
  }
},
async fetchCompany() {
  try {
    const response = await axios.get('show_companies');

    this.companyData = response.data.data.company;
    if(response.data.data.company.city){
        this.companyData.city_id=response.data.data.company.city.id

    }
  } catch (error) {
    console.error('Error fetching cities details:', error);
  }
},

    editCompany() {
      const formData = new FormData();


      // eslint-disable-next-line no-restricted-syntax, guard-for-in
      for (const key in this.companyData) {
        if (key !== "image") {
          formData.append(key, this.companyData[key]);
        }
        if (this.image) {
          formData.append("image", this.image);
        }
      }
      formData.delete('longitude')
      formData.delete('latitude')
      this.loader = true;
      axios
        .post("update_companies", formData)
        .then((res) => {
          if (res.status === 200 || res.status === 201) {
            this.showModal = false;
            window.location.reload();
            this.$toast.success("تم التعديل بنجاح ", {
              duration: 5000,
              position: "bottom-left",
            });
          }
        })
        .catch((error) => {
          if (error.response.status === 500) {
            this.$toast.error(" هناك خظأ ما  ", {
              duration: 5000,
              position: "bottom-left",
            });
          }
        })
        .finally(() => {
          this.loader = false;
        });
    },
    openModal() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
  },
};
</script>
<style>
@import "vue-select/dist/vue-select.css";
</style>